import api from "../api";

const state = {
    headpage: null
};

const getters =  {
    getHeadPage(state){
        return state.headpage == null ? '' : state.headpage;
    }
};

const mutations = {
    setHeadPage: function(state, headpage){
        state.headpage = headpage;
    }
};

const actions = {
    loadHeadpage(){
        return api.pse.getHead();
    },
    loadToPSE({commit}, data){
        return api.pse.toPSE(data);
    },
    loadValidatePSE({commit}, data){
        return api.pse.validatePSE(data);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};